import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import Paper from "@material-ui/core/Paper";

// Mesmo desenho da barra "Dados do contato" (cartao do topo + campos em
// duas colunas), enquanto o atendimento carrega.
const ContactDrawerSkeleton = ({ classes }) => {
	return (
		<div className={classes.content}>
			<Paper square variant="outlined" className={classes.cartao}>
				<div className={classes.topo}>
					<Skeleton animation="wave" variant="circle" width={64} height={64} />
					<div style={{ flex: 1 }}>
						<Skeleton animation="wave" height={22} width="80%" />
						<Skeleton animation="wave" height={18} width="50%" />
					</div>
				</div>
			</Paper>
			<Paper square variant="outlined" className={classes.cartao}>
				<div className={classes.campos}>
					{[0, 1, 2, 3, 4, 5].map((i) => (
						<Skeleton key={i} animation="wave" variant="rect" height={40} style={{ borderRadius: 9 }} />
					))}
				</div>
			</Paper>
		</div>
	);
};

export default ContactDrawerSkeleton;
